export enum AccountRequestType {
  Password = 'password',
  Invite = 'invite',
  Activation = 'activation',
}
